import React from 'react';

const alertStyles = {
  success: {
    backgroundColor: 'var(--color-success-bg)',
    color: 'var(--color-success-text)',
    borderRight: '4px solid var(--color-success)',
  },
  error: {
    backgroundColor: 'var(--color-danger-bg)',
    color: 'var(--color-danger-text)',
    borderRight: '4px solid var(--color-danger)',
  },
  warning: {
    backgroundColor: 'var(--color-warning-bg)',
    color: 'var(--color-warning-text)',
    borderRight: '4px solid var(--color-warning)',
  },
  info: {
    backgroundColor: 'var(--color-info-bg)',
    color: 'var(--color-info-text)',
    borderRight: '4px solid var(--color-info)',
  },
};

export default function Alert({ type = 'info', children, style, onDismiss, ...rest }) {
  return (
    <div
      {...rest}
      data-testid={rest['data-testid'] || `alert-${type}`}
      style={{
        padding: '10px 16px',
        borderRadius: 'var(--radius-sm)',
        fontSize: 'var(--font-size-base)',
        marginBottom: 'var(--sp-lg)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 'var(--sp-sm)',
        ...alertStyles[type] || alertStyles.info,
        ...style,
      }}
    >
      <span style={{ flex: 1 }}>{children}</span>
      {onDismiss && (
        <button
          onClick={onDismiss}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '16px',
            opacity: 0.6,
            padding: '0 4px',
            color: 'inherit',
          }}
        >
          ✕
        </button>
      )}
    </div>
  );
}

export function ErrorAlert({ children, style }) {
  return <Alert type="error" style={style}>{children}</Alert>;
}

export function SuccessAlert({ children, style }) {
  return <Alert type="success" style={style}>{children}</Alert>;
}
